/**
 * create by y5ma 2019-08-06 15:05:36
 * utils functions
 */
import crypto from 'crypto';

const createSignBody = (authParams) => {
  const { appKey, appSecret, api, data } = authParams;
  const params = {
    api,
    appKey,
    timestamp: parseInt(new Date().getTime() / 1000, 10),
    data,
  };

  const sortedParamsKey = Object.keys(params).sort();
  let signString = '';
  sortedParamsKey.forEach(key => {
    signString += signString === '' ? `${key}=${params[key]}` : `&${key}=${params[key]}`;
  });
  const signStringBase64 = Buffer.from(signString, 'utf8').toString('base64');
  const signStringWithSecret = `${appSecret}:${signStringBase64}`;
  const sign = crypto
    .createHash('sha1')
    .update(signStringWithSecret, 'utf8')
    .digest('hex');

  params.sign = sign;

  return params;
};

export default {
  createSignBody: createSignBody
};
